exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._wave__wave__16iAr {\n  text-align: center;\n  font-size: 10px;\n  white-space: nowrap;\n  margin: auto; }\n  ._wave__wave__16iAr ._wave__rect__3XGXu {\n    height: 100%;\n    display: inline-block;\n    margin-right: 2px;\n    animation: _wave__sk-waveStretchDelay__1K-ms 1.2s infinite ease-in-out; }\n    ._wave__wave__16iAr ._wave__rect__3XGXu:last-child {\n      margin-right: 0; }\n  ._wave__wave__16iAr ._wave__rect1__2ZL0A {\n    animation-delay: -1.2s; }\n  ._wave__wave__16iAr ._wave__rect2__QbulJ {\n    animation-delay: -1.1s; }\n  ._wave__wave__16iAr ._wave__rect3__3CVff {\n    animation-delay: -1s; }\n  ._wave__wave__16iAr ._wave__rect4__1jmgp {\n    animation-delay: -0.9s; }\n  ._wave__wave__16iAr ._wave__rect5__1Fdqb {\n    animation-delay: -0.8s; }\n\n@keyframes _wave__sk-waveStretchDelay__1K-ms {\n  0%, 40%, 100% {\n    transform: scaleY(0.4); }\n  20% {\n    transform: scaleY(1); } }\n", ""]);

// exports
exports.locals = {
	"wave": "_wave__wave__16iAr",
	"rect": "_wave__rect__3XGXu",
	"sk-waveStretchDelay": "_wave__sk-waveStretchDelay__1K-ms",
	"rect1": "_wave__rect1__2ZL0A",
	"rect2": "_wave__rect2__QbulJ",
	"rect3": "_wave__rect3__3CVff",
	"rect4": "_wave__rect4__1jmgp",
	"rect5": "_wave__rect5__1Fdqb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/spin/_wave.scss
// module id = 422
// module chunks = 0 1